module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.35.02.1a713c68.jpg";